import React from 'react';
import {Box, Typography} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import {recommendsGridStyles} from '../../features/recommendations/RecommendsGrid/styles';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';

interface DisabledWrapperProps {
  children: React.ReactNode;
}

const DisabledWrapper: React.FC<DisabledWrapperProps> = ({children}) => {
  const classes = recommendsGridStyles();

  return (
    <Box sx={{position: 'relative', borderRadius: '8px', overflow: 'hidden'}}>
      {children}
      <FeatureBoundary
        showErrorIfDenied={false}
        features={[
          GlobalPermissionEnum.can_access_pad_relationship_manager_handover_modal_FE,
        ]}
      >
        <Box sx={classes.overlay}>
          <LockIcon sx={classes.lockIcon} />
          <Typography sx={classes.overlayText}>
            As a Relationship Manager you are unable to create or edit requirements
          </Typography>
        </Box>
      </FeatureBoundary>
    </Box>
  );
};

export default DisabledWrapper;
